var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details-view" }, [
    _c(
      "div",
      { staticClass: "main-contain" },
      [
        _c(
          "el-form",
          {
            staticClass: "section",
            attrs: {
              "label-position": "right",
              "label-width": "70px",
              "label-suffix": ":"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "app-main-inner-row",
                staticStyle: { "flex-direction": "column" }
              },
              [
                _c("el-divider", { attrs: { "content-position": "left" } }, [
                  _vm._v(_vm._s(_vm.$t("SystemDocking.ImportSettings")))
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("SystemDocking.BusinessType") } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.form.type,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "type", $$v)
                          },
                          expression: "form.type"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: "SI" } }, [
                          _vm._v(_vm._s(_vm.$t("SystemDocking.OceanImport")))
                        ]),
                        _c("el-radio", { attrs: { label: "AI" } }, [
                          _vm._v(_vm._s(_vm.$t("SystemDocking.AirCargoImport")))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "app-main-inner-row",
                staticStyle: { "flex-direction": "column" }
              },
              [
                _c("el-divider", { attrs: { "content-position": "left" } }, [
                  _vm._v(_vm._s(_vm.$t("SystemDocking.ImportFile")))
                ]),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SystemDocking.File") } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "flex-start"
                            }
                          },
                          [
                            _c(
                              "el-upload",
                              {
                                ref: "uploader",
                                attrs: {
                                  accept: _vm.accept.join(","),
                                  action:
                                    _vm.URL.systemDocking.kef.importBill +
                                    "?lob=" +
                                    _vm.form.type +
                                    "&fileFlagNo=" +
                                    _vm.fileFlagNo,
                                  "auto-upload": false,
                                  headers: {
                                    sessionId: _vm.$store.getters.token
                                  },
                                  "before-upload": _vm.beforeUpload,
                                  "on-error": _vm.onError,
                                  "on-success": _vm.onSuccess
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      slot: "trigger",
                                      size: "small",
                                      type: "primary"
                                    },
                                    slot: "trigger"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SystemDocking.SelectFile"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-link",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      type: "primary",
                                      href: _vm.importTemplate,
                                      download: _vm.importTemplateName
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SystemDocking.DownloadTemplate")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 10 } },
                  [
                    _c("el-form-item", [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("span", { staticClass: "orange" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "SystemDocking.ReminderCannotExceed100Lines"
                                )
                              )
                            )
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.submit }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SystemDocking.ConfirmImport"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }